import { AuthActions, AuthSaveTokenAction } from "./auth.actions";

export interface AuthState {
  token?: string;
}

/** The default state of the authReducer. */
export const DEFAULT_STATE: AuthState = {
  token: undefined,
};

/** The authReducer, handling the part of the state related to authentication context. */
export const reducer = (state: AuthState = DEFAULT_STATE, action: AuthSaveTokenAction): AuthState => {
  switch (action.type) {
    case AuthActions.AUTH_SAVE_TOKEN:
      return { ...state, token: action.token };
    default:
      return state;
  }
};
